import { useDebounceFn } from 'ahooks';
import { useImageCacheLocal } from '@/pages/aigc/hooks/useImageCacheLocal';
import { downloadFile } from '@home/utils/file';
import { useDownloadNotification } from '../components/DownloadLink/hooks';

/**
 * COS 文件下载 Hook
 * 利用 useImageCacheLocal 的签名缓存能力，获取签名 URL 后通过 <a download> 方式下载文件
 * 内置 useDebounceFn 防止重复点击触发多次下载
 */
export const useCosDownload = () => {
  const { getSignedUrl } = useImageCacheLocal();
  const { setNoticeStatus } = useDownloadNotification();

  /**
   * 下载 COS 文件（内置防抖，防止重复点击）
   * @param cosUrl - COS 原始链接
   * @param fileName - 下载保存的文件名
   */
  const { run: downloadCosFile } = useDebounceFn(
    async (cosUrl: string, fileName: string) => {
      if (!cosUrl) return;
      setNoticeStatus('loading');
      try {
        const signedUrl = await getSignedUrl(cosUrl, undefined, true);
        if (signedUrl) {
          // 追加 attachment 参数，避免跨域 URL 下 pdf/txt 被浏览器直接预览
          const sep = signedUrl.includes('?') ? '&' : '?';
          downloadFile(`${signedUrl}${sep}response-content-disposition=attachment`, fileName);
          setNoticeStatus('success');
        }
      } catch (e) {
        console.error('COS 文件下载失败:', e);
        setNoticeStatus('error');
      }
    },
    { wait: 500 },
  );

  return { downloadCosFile };
};
